
import { Component, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { Options, ImageResult } from 'ngx-image2dataurl';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-file-uploader',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent {
    @Output() passFile: EventEmitter<any> = new EventEmitter<any>();

    public error: any;
    public src: string = null;
    public fileName: string = null;
    public input: File;
    public file_image_form: FormGroup; 


    options: Options = {
      allowedExtensions: ['PDF', 'DOC', 'DOCX', 'MSWORD', 'JPEG', 'JPG', 'XLSX', 'XLS', 'PNG', 'RTF', 'GIF']
    };

    constructor(private _fb: FormBuilder, private toastr: ToastrService){
      this.file_image_form = this._fb.group({
        file_name                : [null],
        image_picker             : [null]
      });
    }

    selected(fileResult: ImageResult) {
      //console.log('fileResult: ',fileResult);
      if (fileResult.error) 
      {
        this.toastr.error('','Error: Extension Not Allowed', {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true,
        });
      }else{
        this.src = fileResult.dataURL;
        this.fileName = fileResult.file.name;
        this.file_image_form.controls.file_name.setValue(this.fileName)
        this.passFile.emit(fileResult);
      };
    }

    removeFile():void{
        this.file_image_form.controls.file_name.setValue(null);
        this.file_image_form.controls.image_picker.setValue(null);
        this.src = null;
        this.fileName = null;
        this.file_image_form.controls.file_name.setValue(null);
        this.passFile.emit(null);
    }

}